/* eslint-disable class-methods-use-this */
/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @author Satyaki Bose
 * @file StudentAssignmentDueDatesService.js
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS, ASSIGNMENT_GET_QUERY } from '../common/Constants';

export default class StudentAssignmentDueDatesPostService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.STUDENT_ASSIGNMENT_DUE_DATES_POST_REQUESTED, 'studentAssignmentDueDatesPostStatus');
  }

  handleEvent(eventName, eventData) {
    const { courseId, studentId, assignments } = eventData;

    return this.getClient('marin').post(
      `/aet/courses/${courseId}/students/${studentId}/assignment-due-date-overrides`,
      { assignments }
    );
  }

  handleResponse(response, eventData) {
    const { courseId, studentId } = eventData;

    Framework.getEventManager().publish(AET_STORE_EVENTS.STUDENT_ASSIGNMENT_DUE_DATES_POST_COMPLETED, {
      response,
      courseId,
      studentId,
      assignments: eventData.assignments
    });

    Framework.getEventManager().publish(AET_STORE_EVENTS.ASSIGNMENT_GET_REQUESTED, {
      contextId: courseId,
      studentId,
      ...ASSIGNMENT_GET_QUERY.STUDENT
    });
  }

  handleError(error, eventData) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.STUDENT_ASSIGNMENT_DUE_DATES_POST_FAILED, {
      error,
      ...eventData
    });
  }
}
